import type { InclusionOption } from "app/pages/sales-intelligence/types/commonMaps";

import type { IEmployeeLocationFilterDto } from "../types/filter-values";

export const assembleEmployeeLocationFilterDTO = (
    inclusion: InclusionOption,
    codes: readonly number[],
    regions: readonly string[],
): IEmployeeLocationFilterDto | undefined => {
    if (!codes.length && !regions.length) {
        return undefined;
    }

    return { inclusion, codes, regions };
};
